export function normaliseCartQuantity(value) {
  const number = Number.parseInt(value, 10);
  return Number.isFinite(number) ? Math.max(0, number) : 0;
}

export function quantityAfterAction(value, direction) {
  return Math.max(0, normaliseCartQuantity(value) + (direction > 0 ? 1 : -1));
}

export function submitCartUpdate(root, form) {
  if (!root || !form || root.dataset.cartQuantitySubmitting === 'true') return false;

  root.dataset.cartQuantitySubmitting = 'true';
  root.setAttribute('aria-busy', 'true');
  root.querySelectorAll('[data-quantity-minus],[data-quantity-plus]').forEach((control) => {
    control.disabled = true;
  });
  root.querySelectorAll('input[name="updates[]"]').forEach((input) => {
    input.readOnly = true;
  });

  if (typeof form.requestSubmit === 'function') {
    const updateButton = form.querySelector?.('[type="submit"][name="update"]');
    if (updateButton) form.requestSubmit(updateButton);
    else form.requestSubmit();
  } else if (typeof form.submit === 'function') {
    form.submit();
  } else {
    return false;
  }
  return true;
}

export function initialiseCartQuantity(root) {
  if (!root || root.dataset.cartQuantityBound === 'true') return;
  root.dataset.cartQuantityBound = 'true';

  const form = root.querySelector('#CartForm');
  if (!form) return;

  root.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-quantity-minus],[data-quantity-plus]');
    if (!button || !root.contains(button)) return;

    const input = button.parentElement?.querySelector('input[name="updates[]"]');
    if (!input) return;

    event.preventDefault();
    const direction = button.hasAttribute('data-quantity-plus') ? 1 : -1;
    input.value = String(quantityAfterAction(input.value, direction));
    submitCartUpdate(root, form);
  });

  root.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches?.('input[name="updates[]"]') || !root.contains(input)) return;

    input.value = String(normaliseCartQuantity(input.value));
    submitCartUpdate(root, form);
  });
}

function initialiseAllCartQuantities() {
  document.querySelectorAll('[data-cart]').forEach(initialiseCartQuantity);
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAllCartQuantities);
  } else {
    initialiseAllCartQuantities();
  }
}
